const state = {
    operateLogDataFields: [
        {
            key: "status",
            label: "狀態",
            sortable: true,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "alarmCode",
            label: "代碼",
            sortable: true,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "alarmDetail",
            label: "代碼說明",
            sortable: true,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "startTime",
            label: "開始時間",
            sortable: true,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "endTime",
            label: "結束時間",
            sortable: true,
            class: "font-family-dfyuanstd-w5"
        },
        {
            key: "durationTime",
            label: "持續時間",
            sortable: true,
            class: "font-family-dfyuanstd-w5"
        }
    ],
    operateLogDataItem: [],
    operateLogTableStyle: "",
}
const getters = {
    get_operateLogDataFields: state => {
        return state.operateLogDataFields
    },
    get_operateLogDataItem: state => {
        return state.operateLogDataItem
    },
    get_operateLogTableStyle: state => {
        return state.operateLogTableStyle
    },
}
const actions = {
    set_operateLogDataFields(context, array) {
        context.commit('SET_OPERATELOGDATAFIELDS', array);
    },
    set_operateLogDataItem(context, array) {
        context.commit('SET_OPERATELOGDATAITEM', array);
    },
    clear_operateLogDataItem(context, array) {
        context.commit('CLEAR_OPERATELOGDATAITEM', array);
    },
    set_operateLogTableStyle(context, string = '') {
        context.commit('SET_OPERATELOGTABLESTYLE', string);
    },
}
const mutations = {
    SET_OPERATELOGDATAFIELDS(state, array) {
        state.operateLogDataFields = array;
    },
    SET_OPERATELOGDATAITEM(state, array) {
        state.operateLogDataItem = array;
    },
    CLEAR_OPERATELOGDATAITEM(state, array) {
        state.operateLogDataItem = [];
    },
    SET_OPERATELOGTABLESTYLE(state, string) {
        state.operateLogTableStyle = string;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/operateLogData.js